import { render, staticRenderFns } from "./DialogClose.vue?vue&type=template&id=5c1a6f42&"
import script from "./DialogClose.vue?vue&type=script&lang=ts&"
export * from "./DialogClose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports